import { apiHost } from '../../../config';
import { get } from '../../requests';

export default async function getAllSchoolTypesAsAdmin() {
  return get(`${apiHost}/api/admin/school_types`);
}
